/**
 * Calculate range of down-payment buckets based on
 * @param minDown
 */
export function getDownPaymentBuckets(minDown: number) {
  const nearest1000 = Math.round(minDown / 1_000) * 1_000;

  return [nearest1000 + 1_000, nearest1000 + 2_500, nearest1000 + 5_000];
}
